export let deliveryplace = {
	 "HK办公室地址": {
				'deliveryplace': "A,10/F,KWUN TONG IND CTR BLK 01,KWUN TONG RD 472-484,HongKong 觀塘工業中心 1 期 10 楼 10A九龍觀塘觀塘道472-484號",
				'contacts': 'Candice/Jason',
				'contacts_tel': '+852-51788053/+852 3689 9667'
		},
		"飞力达地址": {
				'deliveryplace': "Feiliks Logistics (ASIA) LTD 地址: 香港新界天水圍蝦尾新村路57號  Address: No.57 , Ha Mei San Tsuen Road , Tin Shiu Wei , NT , Hong Kong",
				'contacts': 'Doris Chan',
				'contacts_tel': '+852 2585 6385'
		},
		"深圳2706仓库": {
				'deliveryplace': "广东省深圳市南山区阳光科创中心 B 座2706",
				'contacts': '王翩翩',
				'contacts_tel': '13128592879'
		},
		"深圳1416仓库": {
				'deliveryplace': "广东省深圳市南山区阳光科创中心 B 座1416",
				'contacts': '王翩翩',
				'contacts_tel': '13128592879'
		},
		"其他": {
				'deliveryplace': "",
				'contacts': '',
				'contacts_tel': ''
		},
}